// Сколько дней освобождённый R2-объект живёт до того, как уборщик его удалит.
// Ключ — media_assets.role. См. спеку archive-model §5.
// Живёт в shared, потому что диалог архивации во фронте показывает срок
// («Освободить файл через N дней») — хардкодить его в UI нельзя.
export const RETENTION_DAYS = {
    clip_variant: 7,
    clip_foundation: 7,
    clip_banner: 7,
    clip_final: 7,
    film_source: 30,
    film_audio: 30,
    draft_video: 7,
    draft_source: 7,
    draft_generated: 7,
    post_video: 7,
};
export const DEFAULT_RETENTION_DAYS = 7;
export function retentionFor(role) {
    return RETENTION_DAYS[role] ?? DEFAULT_RETENTION_DAYS;
}
//# sourceMappingURL=retention.js.map